/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon-status-market': {
    width: 9,
    height: 9,
    viewBox: '0 0 9 9',
    data: '<path pid="0" d="M6.683.646c1.152 0 2.084 1.749 2.084 3.908s-.932 3.908-2.084 3.908c-.424 0-.817-.239-1.145-.646L.5 5.44C.107 4.996.107 4.11.5 3.667l5.038-2.375c.33-.408.723-.646 1.145-.646zm-5.227 5.57l.693.321c.015.68-.038.543 1.193 1.13.188.09.418.036.544-.129l.108-.142.638.295c-.205.265-.473.704-1.105.704-.324 0-.426-.082-1.414-.553-.74-.353-.644-1.064-.657-1.627zm5.227-4.869c-.64 0-1.382 1.4-1.382 3.207 0 1.806.744 3.207 1.382 3.207.64 0 1.382-1.4 1.382-3.207 0-1.806-.744-3.207-1.382-3.207zm-.89 2.196a1.011 1.011 0 1 1 0 2.022l-.027-.002A3.03 3.03 0 0 1 5.6 4.546c0-.043 0-.084.002-.125a3.13 3.13 0 0 1 .15-.874.25.25 0 0 1 .04-.004z" fill-rule="nonzero"/>'
  }
})
